import React from 'react'

const Hexagon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 32 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.042 9.28809V26.7109L15.9531 35.4229L0.864258 26.7109V9.28809L15.9531 0.576172L31.042 9.28809Z"
        stroke="#DA0808"
      />
    </svg>
  )
}

export default Hexagon
